import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ic-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss'],
})
export class AutoCompleteComponent implements OnInit {
  @Input() autoCompleteItemList: KeyValue<number, string>[];
  @Output() autoCompleteEvent = new EventEmitter<KeyValue<number, string>>();
  public searchItem: string;
  public filteredItemList: KeyValue<number, string>[];

  constructor() {}

  ngOnInit(): void {}

  onSelectedItem(item: KeyValue<number, string>) {
    this.searchItem = null;
    this.filteredItemList = [];
    this.autoCompleteEvent.emit(item);
  }

  onChange() {
    if (!this.searchItem) {
      this.filteredItemList = [];
      return;
    }
    this.filteredItemList = this.autoCompleteItemList.filter((item) => {
      return item.value.toLowerCase().includes(this.searchItem.toLowerCase());
    });
  }
}
